/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseUnionGradingNoneTypeData } from './genericApiResponseUnionGradingNoneTypeData';
import type { GenericApiResponseUnionGradingNoneTypeMessage } from './genericApiResponseUnionGradingNoneTypeMessage';
import type { GenericApiResponseUnionGradingNoneTypePagination } from './genericApiResponseUnionGradingNoneTypePagination';
import type { GenericApiResponseUnionGradingNoneTypeError } from './genericApiResponseUnionGradingNoneTypeError';

export interface GenericApiResponseUnionGradingNoneType {
  data?: GenericApiResponseUnionGradingNoneTypeData;
  message?: GenericApiResponseUnionGradingNoneTypeMessage;
  pagination?: GenericApiResponseUnionGradingNoneTypePagination;
  error?: GenericApiResponseUnionGradingNoneTypeError;
  statusCode?: number;
}
